// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getLabReviews } from '../../apis/lab';
import { LoadingType } from '../../types/Common';
import { getLabReviewsActions } from '../actionCreators/getLabReviewsActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: getLabReviewsActions.success,
  failure: getLabReviewsActions.failure
};

type RequestActionTypes = ActionType<
  typeof getLabReviewsActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const getLabReviewsEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getLabReviewsActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, loadingType = LoadingType.NEW, condition } = action.payload;
      // send api promise
      return getLabReviews(id, condition)
        .then((response: any) => {
          // handle success case here
          return getLabReviewsActions.success({
            LabReviewsStatistics: response.data.data,
            LabReviewsList: response.data.list,
            id,
            loadingType
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return getLabReviewsActions.failure({ error });
        });
    })
  );
};
